// extracted by mini-css-extract-plugin
export default {"textComponent":"SignUp_textComponent__cOtCP"};